// src/components/AboutPage.tsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const AboutPage: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col>
          <div className="text-center mb-4">
            <h1 className="display-4 fw-bold" style={{ color: "#810081" }}>About Natakiya</h1>
            <div 
              className="mx-auto" 
              style={{ 
                width: "80px", 
                height: "4px", 
                background: "linear-gradient(45deg, #810081, #FFD600)", 
                marginBottom: "2rem" 
              }}
            ></div>
            <p className="lead text-muted">Your gateway to the world of theater and performing arts</p>
          </div>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={6} className="mb-4 mb-md-0">
          <h2 className="mb-4" style={{ color: "#810081" }}>Our Story</h2>
          <p>Founded in 2023, Natakiya was born from a passion for theater and a desire to create a platform that connects theater enthusiasts, artists, and audiences across the country.</p>
          <p>Our mission is to celebrate the rich tradition of theatrical arts while making it more accessible to everyone. We believe in the power of theater to inspire, educate, and transform lives.</p>
          <p>What started as a small initiative has grown into a vibrant community of theater lovers, performers, directors, and playwrights all united by their love for the stage.</p>
        </Col>
        <Col md={6}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <h3 className="mb-3" style={{ color: "#810081" }}>Our Vision</h3>
              <p>To become the premier platform for theater arts in India, connecting audiences with exceptional theatrical experiences and supporting the growth of theater communities nationwide.</p>
              
              <h3 className="mb-3 mt-4" style={{ color: "#810081" }}>Our Values</h3>
              <ul>
                <li><strong>Artistic Excellence</strong> - Promoting quality and creativity in theatrical productions</li>
                <li><strong>Cultural Preservation</strong> - Honoring traditional art forms while embracing innovation</li>
                <li><strong>Community Building</strong> - Fostering connections between theater groups and audiences</li>
                <li><strong>Accessibility</strong> - Making theater more accessible to diverse audiences</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col>
          <Card className="border-0 bg-light">
            <Card.Body className="p-4 text-center">
              <h2 className="mb-4" style={{ color: "#810081" }}>What We Offer</h2>
              <Row className="g-4">
                <Col md={4}>
                  <div className="mb-3">
                    <i className="bi bi-journal-text" style={{ fontSize: "2.5rem", color: "#810081" }}></i>
                  </div>
                  <h4>Articles & News</h4>
                  <p className="text-muted">Stay updated with the latest theater news, reviews, and in-depth articles about the performing arts.</p>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <i className="bi bi-people" style={{ fontSize: "2.5rem", color: "#810081" }}></i>
                  </div>
                  <h4>Theater Community</h4>
                  <p className="text-muted">Connect with theater groups, artists, and fellow enthusiasts who share your passion for the stage.</p>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <i className="bi bi-camera-video" style={{ fontSize: "2.5rem", color: "#810081" }}></i>
                  </div>
                  <h4>Video Content</h4>
                  <p className="text-muted">Watch interviews, behind-the-scenes footage, and highlights from notable performances.</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col className="text-center">
          <h2 className="mb-4" style={{ color: "#810081" }}>Join Our Journey</h2>
          <p className="lead">We invite you to be part of our growing community as we continue to celebrate and promote the magic of theater.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutPage;
